// extracted by mini-css-extract-plugin
module.exports = {"articlesContainer":"ArticlesIndex-module--articlesContainer--2KK9M"};